import {
  BooleanField,
  CreateButton,
  Datagrid,
  DateField,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { Button } from "@mui/material";

type Invite = { id: string; note: string | null; deeplink: string; used: boolean };

const CopyDeeplink = () => {
  const r = useRecordContext<Invite>();
  if (!r?.deeplink) return null;
  return (
    <Button size="small" variant="outlined" onClick={() => void navigator.clipboard.writeText(r.deeplink)}>
      Копировать ссылку
    </Button>
  );
};

const Actions = () => (
  <TopToolbar>
    <CreateButton label="Создать приглашение" />
  </TopToolbar>
);

export function FriendHostInviteList() {
  return (
    <List actions={<Actions />} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="note" label="Метка" />
        <BooleanField source="used" label="Использован" />
        <FunctionField label="Deep-link" render={(r: Invite) => r.deeplink} />
        <CopyDeeplink />
        <DateField source="expires_at" label="Истекает" showTime />
        <DateField source="created_at" label="Создан" showTime />
      </Datagrid>
    </List>
  );
}
